import onPillSuggestionSelected from '../actions/onPillSuggestionSelected';
import onRemoveSuggestionPillInternal from '../actions/onRemoveSuggestionPillInternal';
import isSuggestionPillInSearchBox from '../selectors/isSuggestionPillInSearchBox';
import getScenarioStore from '../store/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(onPillSuggestionSelected, actionMessage => {
    const { suggestionPill, scenarioId } = actionMessage;

    // Don't add pill to search box if it's already there.
    if (isSuggestionPillInSearchBox(suggestionPill, scenarioId)) {
        return;
    }

    const store = getScenarioStore(scenarioId);
    const pillId = suggestionPill.ReferenceId;

    /**
     * Add the suggestion pill to the collection, as well as adding its ID to
     * the array of IDs to maintain order.
     */
    store.suggestionPills.set(pillId, suggestionPill);
    store.suggestionPillIds.push(pillId);
});

mutator(onRemoveSuggestionPillInternal, actionMessage => {
    const { suggestionPillId, suggestionPillIndex, scenarioId } = actionMessage;
    const store = getScenarioStore(scenarioId);

    // Remove all traces of suggestion pill from store.
    store.suggestionPills.delete(suggestionPillId);
    store.suggestionPillIds.splice(suggestionPillIndex, 1);

    // Reset selected pill index.
    store.selectedPillIndex = createDefaultSearchStore().selectedPillIndex;
});
